import React, { useState, useEffect, useLayoutEffect, useContext } from "react";
import { GridToolbarContainer, GridToolbarQuickFilter } from "@mui/x-data-grid";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import axios from "axios";
import { useSelector } from "react-redux";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "react-dropdown-select";
import Loader from "../CommonLoader";
import { useNavigate } from "react-router-dom";
import ApexCharts from "react-apexcharts";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import SquareIcon from "@mui/icons-material/Square";
import ErrorIcon from '@mui/icons-material/Error';
import { Helmet } from 'react-helmet';
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { SetredirectValue } from "../../../Store/PageredirectSlice";
import Rightsidebar from "../Rightsidebar/Rightsidebar";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import { interpolateRgb } from "d3-interpolate";
import { color } from "d3-color";
import { AppContext } from "../../../Context/Context";
import { SetDomainHeader } from "../../../Store/DomainData";
import CommonAlert from "../../../Commonalert/commonalert";
import ProgressBar from "./ProgressBar"
import DashboardCards from "./DashboardCards"
import useMediaQuery from '@mui/material/useMediaQuery';
import { Tooltip } from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import Grid from '@mui/material/Grid';
import DatagridComp from "../DatagridComp";
import { Container } from '@mui/material';
import { Card, Typography, Chip, } from "@mui/material";
import BarChartIcon from '@mui/icons-material/BarChart';
import BugReportIcon from '@mui/icons-material/BugReport';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Commoncard from "../Commoncard";
import RankedKeywordssvg from "../Asset/esocardicon/FileAccessibilityReport/Score.svg";

const MainDashboard = (props) => {

  const navigate = useNavigate();
  const [cardData, setCardData] = useState([]);
  const [loading, setLoading] = useState(false);
  const rows = cardData ?? [];
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;
  const [completedate, setcompletedate] = useState("");
  const [searchengine, setsearchengine] = useState("");
  const [country, setcountry] = useState("");
  const [selectval, setSelectval] = useState("");
  const [selectvalengine, setselectvalengine] = useState("");
  const [selectvalcountry, setselectvalcountry] = useState("");
  const [selectvalengineTop, setselectvalengineTop] = useState("");
  const [selectvalcountryTop, setselectvalcountryTop] = useState("");
  const [TopFiveMetrics, SetTopFiveMetrics] = useState([]);
  const [SelectdMetrics, SetSelectdMetrics] = useState("");
  const [SelectdGraphMetrics, SetSelectdGraphMetrics] = useState("line");
  const [ShowTraffic, SetShowTraffic] = useState(false);
  const [ShowTop, SetShowTop] = useState(false);
  const [ShowTrafficMsg, SetShowTrafficMsg] = useState('')
  const [ShowTopMsg, SetShowTopMsg] = useState('')
  const [faqData, setfaqData] = useState("2")
  const [toggle, setToggle] = useState(false);
  const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [modalIsOpenTop, setIsOpenTop] = React.useState(false);
  const [validation, setValidation] = useState({
    dateerror: "",
  });
  const [validationTop, SetvalidationTop] = useState("");
  const [dashboardcount, setdashboardcount] = useState(1)
  const [topfivetraffic, setTopfivetraffic] = useState(false)
  const [topseventraffic, setTopseventraffic] = useState(false)
  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const isMobile = useMediaQuery('(max-width:600px)');
  const isTablet = useMediaQuery('(min-width:600px) and (max-width:900px)');
  const [autoheightval, SetAutoheightval] = useState(true)
  const [SeriousData, setSeriousData] = useState([]);
  const [CriticalData, setCriticalData] = useState([]);
  const [ModerateData, setModerateData] = useState([]);
  const [MinorData, setMinorData] = useState([]);
  const [SeriousCount, setSeriousCount] = useState(0);
  const [CriticalCount, setCriticalCount] = useState(0);
  const [ModerateCount, setModerateCount] = useState(0);
  const [MinorCount, setMinorCount] = useState(0);
  const [CriticalPercentage, setCriticalPercentage] = useState(0);
  const [SeriousPercentage, setSeriousPercentage] = useState(0);
  const [ModeratePercentage, setModeratePercentage] = useState(0);
  const [MinorPercentage, setMinorPercentage] = useState(0);
  const [CriticalPerc, setCriticalPerc] = useState({});
  const [TotalIssues, setTotalIssues] = useState(0);
  const [tableLoading, setTableLoading] = useState(true);
  const [ImpactBreakdown, setImpactBreakdown] = useState({});
  const [FailedIssues, setFailedIssues] = useState([]);

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer style={{ display: "flex", justifyContent: "space-between", padding: "8px", alignItems: "end" }}>
        <div className="below_note_ranking icon over_all_accessibility">
          <div className="below_note_ranking">
            *Note: N/R is Not Ranked, N/A is Not Available

          </div>
          <div className="green">
            <TrendingUpIcon /> - High
          </div>
          <div className="rose">
            <TrendingDownIcon /> - Low
          </div>
          <div className="orange">
            <SquareIcon /> - No Change
          </div>
        </div>
        <GridToolbarQuickFilter
          className="datagrid-search"
        />
      </GridToolbarContainer>
    );
  };

  const [RankedKeywords, SetRankedKeywords] = useState(0);
  const [OnPageErrors, SetOnPageErrors] = useState(0);
  const [TotalInternalLinks, SetTotalInternalLinks] = useState(0);
  const [VisibilityScore, SetVisibilityScore] = useState(0);

  const [HighIssuesData, SetHighIssuesData] = useState([]);
  const [MediumIssuesData, SetMediumIssuesData] = useState([]);
  const [LowIssuesData, SetLowIssuesData] = useState([]);

  const [HighPercentage, setHighPercentage] = useState(0);
  const [MediumPercentage, setMediumPercentage] = useState(0);
  const [LowPercentage, setLowPercentage] = useState(0);

  const [HighCount, SetHighCount] = useState(0);
  const [MediumCount, SetMediumCount] = useState(0);
  const [LowCount, SetLowCount] = useState(0);
  const [TotalCount, SetTotalCount] = useState(0);
  const [widgetcount, SetWidgetcount] = useState(0);
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [domainNameUrl, setDomainNameUrl] = useState({ domain_name: '', domain_url: '' });



  const apihandleClose = () => {
    setapiOpen(false);
  };
  const dispatch = useDispatch();

  const columns = [
    {
      field: "url",
      headerName: "URL",
      minWidth: 400,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
      description: "The web address of a specific page on your website.",
      disableClickEventBubbling: true,
      renderCell: (cardData) => {
        let firstEightLetters = "";
        let lastThreeLetters = "";
        let whoedata = "";
        firstEightLetters = cardData?.row?.url;
        whoedata = firstEightLetters;
        let baseUrl = cardData.row.url.split("/").slice(0, 3).join("/")
        let remaining = cardData.row.url.split("/").slice(3).join("/");
        return (
          <>
            <Tooltip title={cardData.row.url}>
              <div className="prefered_url_external02">
                <a target="_blank" href={cardData?.row?.url} style={{ display: 'flex', flexDirection: 'column' }}>
                  <span className="spanlink">
                    <LinkIcon /> {baseUrl}
                  </span>
                  <span className="spanlink" >{remaining}</span>
                </a>
              </div>
            </Tooltip>
          </>
        );
      },
    },
    {
      field: "changed_metrics",
      headerName: removeUnderscore(SelectdMetrics),
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
      disableClickEventBubbling: true,
      description: SelectdMetrics === "New_Users" ? "First-time visitors within a specified period." : SelectdMetrics === "Sessions" ? "A session represents one visit to your webpage by a user, starting when they enter and ending after a period of inactivity." : SelectdMetrics === "Bounce_Rate" ? "Percentage of visitors who left after viewing only one page." : "Represents the percentage of users who clicked on a link out of the total number of users who viewed it. A higher CTR((Click-Through Rate) indicates better engagement.."
    },
    {
      field: "avg_ranking",
      headerName: "Avg.Rank",
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
      disableClickEventBubbling: true,
      description: "The average position of a webpage in search engine results for specific keywords.",
    },
    {
      field: "this_week_trend",
      headerName: "This Week Trend",
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
      disableClickEventBubbling: true,
      description: SelectdMetrics === "Sessions" ? "Shows the webpage position in terms of traffic sessions for the current week." : "Shows the session position trends for this week, indicating the order of interactions during each period."
    },
    {
      field: "last_week_trend",
      headerName: "Last Week Trend",
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
      disableClickEventBubbling: true,
      description: "Shows the session position trends for last week, indicating the order of interactions during each period."
    },
    {
      field: "changes",
      headerName: "Changes",
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      disableClickEventBubbling: true,
      description: "Refers to the status of a page's ranking or traffic trend over a specified period.",
      sortable: true,
      renderCell: (cardData) => {
        if (cardData.row.changes === "low") {
          return (
            <div className="gain_drop_row" style={{ color: "#ff0000" }}>
              <TrendingDownIcon />
            </div>
          );
        }

        if (cardData.row.changes === "high") {
          return (
            <div className="gain_drop_row" style={{ color: "#008900" }}>
              <TrendingUpIcon />
            </div>
          );
        }

        if (cardData.row.changes === "equal") {
          return (
            <div
              className="gain_drop_row no_change_row"
              style={{ color: "orange" }}
            >
              <SquareIcon />
            </div>
          );
        }
      },
    },
  ];

  const GetdashboardData = async () => {
    setLoading(true);
    SetRankedKeywords(0);
    SetOnPageErrors(0);
    SetTotalInternalLinks(0);
    SetVisibilityScore(0);

    var JobId = "";

    var RankJobId = "";
    var RankCountryId = "";
    var RankEngineId = "";

    if (selectval !== "") {
      if (selectval[0].id !== undefined && selectval[0].id !== "") {
        RankJobId = selectval[0].id;
      }
    }

    if (selectvalcountry !== "") {
      if (
        selectvalcountry[0].search_engine_locale__city__state__country__id !==
        undefined &&
        selectvalcountry[0].search_engine_locale__city__state__country__id !==
        ""
      ) {
        RankCountryId =
          selectvalcountry[0].search_engine_locale__city__state__country__id;
      }
    }

    if (selectvalengine !== "") {
      if (
        selectvalengine[0].search_engine_locale__search_engine__id !==
        undefined &&
        selectvalengine[0].search_engine_locale__search_engine__id !== ""
      ) {
        RankEngineId =
          selectvalengine[0].search_engine_locale__search_engine__id;
      }
    }


    try {


      const result = await axios.get(
        `${process.env.REACT_APP_API_URL}domain/get_user_domains/`, {
        headers: {
          Authorization: `${ApiToken}`,
        },
      }
      )


      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}dashboard/ranked_keywords/?user_domain_id=${esodata.domaindata.value.header_selected ? esodata.domaindata.value.header_selected : result.data[0].id}&job_id=${RankJobId}&rank_section=rank_summary&country_id=${RankCountryId}&search_engine_id=${RankEngineId}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {

        setLoading(false);
        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          if (dashboardcount == 1) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error)
            setdashboardcount(2)
          }

        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });

      if (datavalue?.data) {
        SetRankedKeywords(datavalue.data.ranked_keyword_count);
        SetVisibilityScore(datavalue.data.visibility_score + "%");
      }
    } catch (err) {
      console.log(err);
    }

    try {


      const result = await axios.get(
        `${process.env.REACT_APP_API_URL}domain/get_user_domains/`, {
        headers: {
          Authorization: `${ApiToken}`,
        },
      }
      )

      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}dashboard/on_page_errors/?user_domain_id=${esodata.domaindata.value.header_selected ? esodata.domaindata.value.header_selected : result.data[0].id}&job_id=${JobId}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        setLoading(false);
        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          if (dashboardcount == 1) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error)
            setdashboardcount(2)
          }
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });

      if (datavalue?.data) {
        SetOnPageErrors(datavalue.data.total_on_page_errors_count);
      }
    } catch (err) {
      console.log(err);
    }

    try {


      const result = await axios.get(
        `${process.env.REACT_APP_API_URL}domain/get_user_domains/`, {
        headers: {
          Authorization: `${ApiToken}`,
        },
      }
      )

      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}dashboard/dashboard_total_internal_link_count/?user_domain_id=${esodata.domaindata.value.header_selected ? esodata.domaindata.value.header_selected : result.data[0].id}&job_id=${JobId}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        setLoading(false);
        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          if (dashboardcount == 1) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error)
            setdashboardcount(2)
          }
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });
      if (datavalue?.data) {
        SetTotalInternalLinks(datavalue.data.total_internal_links);
      }
    } catch (err) {
      console.log(err);
    }

    try {


      const result = await axios.get(
        `${process.env.REACT_APP_API_URL}domain/get_user_domains/`, {
        headers: {
          Authorization: `${ApiToken}`,
        },
      }
      )

      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}dashboard/site_audit_summary/?user_domain_id=${esodata.domaindata.value.header_selected ? esodata.domaindata.value.header_selected : result.data[0].id}&job_id=${JobId}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        setLoading(false);
        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          if (dashboardcount == 1) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error)
            setdashboardcount(2)
          }
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });

      if (datavalue?.data) {
        if (datavalue?.data?.top_two_high_issues) {
          SetHighIssuesData(datavalue.data.top_two_high_issues);
        }
        if (datavalue?.data?.top_two_medium_issues) {
          SetMediumIssuesData(datavalue.data.top_two_medium_issues);
        }
        if (datavalue?.data?.top_two_low_issues) {
          SetLowIssuesData(datavalue.data.top_two_low_issues);
        }
        if (datavalue?.data?.total_count) {
          SetTotalCount(datavalue.data.total_count);
        }
        if (datavalue?.data?.medium_count) {
          SetMediumCount(datavalue.data.medium_count);
        }
        if (datavalue?.data?.high_count) {
          SetHighCount(datavalue.data.high_count);
        }
        if (datavalue?.data?.low_count) {
          SetLowCount(datavalue.data.low_count);
        }
        if (datavalue?.data?.high_issue_percentage) {
          setHighPercentage(datavalue.data.high_issue_percentage);
        }
        if (datavalue?.data?.medium_issue_percentage) {
          setMediumPercentage(datavalue.data.medium_issue_percentage);
        }
        if (datavalue?.data?.low_issue_percentage) {
          setMediumPercentage(datavalue.data.low_issue_percentage);
        }
      }


    } catch (err) {
      console.log(err);
    }

    setLoading(false);
  };
  const pageRedirectfun = (e) => {
    localStorage.setItem("eso_redirect_value", e.currentTarget.id);
    dispatch(SetredirectValue(e.currentTarget.id));
    navigate('/internal-link-checker')

  }

  const startfunction = async () => {
    try {

      const result = await axios.get(
        `${process.env.REACT_APP_API_URL}domain/get_user_domains/`, {
        headers: {
          Authorization: `${ApiToken}`,
        },
      }
      )


      if (result.data.length > 0) {
        GetwidgetDatavalue(result.data[0].id);
        getImpactSummaryData(result.data[0].id);
        GethideDatavalue(result.data[0].id);
        LoadCountry("", result.data[0].id);
        LastSevenDaysTrafficReport(result.data[0].id);
      }



      if (!esodata.domaindata.value.header_selected) {
        localStorage.setItem("header_selected", result.data[0].id);
        dispatch(SetDomainHeader({ header_selected: result.data[0].id }));
      }

    } catch (error) {

    }
  }



  useLayoutEffect(() => {
    startfunction();
    GetuserDatavalue();
    GetdashboardData();
    faqdatafun();
    TopFiveMetricsList();
    // getImpactSummaryData();
  }, []);


  const GethideDatavalue = async (userDomain) => {
    try {

      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}dashboard/dashboard_api_control/?user_domain_id=${esodata.domaindata.value.header_selected ? esodata.domaindata.value.header_selected : userDomain}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        setLoading(false);
        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          if (dashboardcount == 1) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error)
            setdashboardcount(2)
          }
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });
      if (datavalue?.data) {
        setTopfivetraffic(datavalue.data.result[0].top_five_traffic)
        setTopseventraffic(datavalue.data.result[0].top_report_seven_days)
      }

    } catch (err) {
      console.log(err);
    }
  };

  const GetuserDatavalue = async () => {
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}accounts/get_user_details/`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        setLoading(false);
        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          if (dashboardcount == 1) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error)
            setdashboardcount(2)
          }
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });
      const header_selected = localStorage.getItem("header_selected");
      if (!header_selected) {
        localStorage.setItem("header_selected", datavalue?.data?.user_domain_id_for_domain_domain_ownership_required);
        dispatch(SetDomainHeader({ header_selected: datavalue?.data?.user_domain_id_for_domain_domain_ownership_required }));
      }
      if (datavalue?.data?.verification_method) {
        localStorage.setItem('verification_method', datavalue?.data?.verification_method);
      } else {
        localStorage.setItem('verification_method', 'txt');
      }
      if (datavalue?.data?.dor_domain_name && datavalue?.data?.dor_domain_url) {
        setDomainNameUrl({ ...domainNameUrl, domain_name: datavalue?.data?.dor_domain_name, domain_url: datavalue?.data?.dor_domain_url });
      }

      if (datavalue?.data) {
        if (datavalue?.data?.is_location_required === true) {
          window.location.href = `${process.env.REACT_APP_DOMAIN}Userdata`;
          return
        }
        if (datavalue?.data?.is_domain_required === true) {
          window.location.href = `${process.env.REACT_APP_DOMAIN}Impadddomain`;
          return
        }

      }

    } catch (err) {
      console.log(err);
    }
  };



  // useEffect(() => {
  //   getImpactSummaryData();
  // },[]);

  const getImpactSummaryData = async (userDomain) => {
    try {


      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}dashboard/accessibility_impact_summary/?user_domain_id=${esodata.domaindata.value.header_selected ? esodata.domaindata.value.header_selected : userDomain}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      );

      const data = response.data;

      const totalIssues = data?.issues?.total_issues || 0;
      const failedIssues = data?.issues?.failed || [];
      const impactTotals = data?.issues?.totals_by_impact || {};
      const CriticalPerc1 = data?.issues?.issue_percentages || {};


      setTotalIssues(totalIssues);
      setImpactBreakdown(impactTotals);
      setFailedIssues(failedIssues);
      setCriticalPerc(CriticalPerc1);


      // Filter by impact levels
      setSeriousData(failedIssues.filter(issue => issue.impact === 'Serious'));
      setCriticalData(failedIssues.filter(issue => issue.impact === 'Critical'));
      setModerateData(failedIssues.filter(issue => issue.impact === 'Moderate'));
      setMinorData(failedIssues.filter(issue => issue.impact === 'Minor'));

      // Set counts
      setSeriousCount(impactTotals.Serious || 0);
      setCriticalCount(impactTotals.Critical || 0);
      setModerateCount(impactTotals.Moderate || 0);
      setMinorCount(impactTotals.Minor || 0);

      // Set Percentage
      setCriticalPercentage(CriticalPerc1.critical_issue_percentage);
      setSeriousPercentage(CriticalPerc1.serious_issue_percentage);
      setModeratePercentage(CriticalPerc1.moderate_issue_percentage);
      setMinorPercentage(CriticalPerc1.minor_issue_percentage);

    } catch (error) {
      setLoading(false);

      const status = error?.response?.status;

      if ([599, 500, 400, 404].includes(status)) {
        if (dashboardcount === 1) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error || "Unexpected error");
        }
      } else if (error?.code === "ERR_NETWORK") {
        navigate('/errorpages');
      }

      console.error("Error fetching impact summary:", error);
    }
  };



  const ImpactSummaryData = (data) => {

    if (replacedata(data?.issue_name) == "lable")
      return <div className="data">
        <div className="seometricdata impact_summary_data"><div className="value1">{data.count}</div>
          <div>{replacedata(data.issue_name)}</div></div>
      </div>
    else if (replacedata(data?.impact) === "Critical")
      return <div className="data">
        <div className="seometricdata impact_summary_data"><div className="value3">{data.count}</div>
          <div className="summary_issue_data">{replacedata(data.issue_name)}</div></div>
      </div>
    else if (replacedata(data?.impact) === "Serious")
      return <div className="data">
        <div className="seometricdata impact_summary_data"><div className="value3">{data.count}</div>
          <div className="summary_issue_data">{replacedata(data.issue_name)}</div></div>
      </div>

    else if (replacedata(data?.impact) === "Moderate")
      return <div className="data">
        <div className="seometricdata impact_summary_data"><div className="value4">{data.count}</div>
          <div>{replacedata(data.issue_name)}</div></div>
      </div>
    else if (replacedata(data?.impact) === "Minor")
      return <div className="data">
        <div className="seometricdata impackt"><div className="value">{data.count}</div>
          <div>{replacedata(data.issue_name)}</div></div>
      </div>

    // console.log("loop",data.issue_name, data.count);
  }





  const GetwidgetDatavalue = async (userDomain) => {
    try {

      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}dashboard/accessibility_axe_score/?user_domain_id=${esodata.domaindata.value.header_selected ? esodata.domaindata.value.header_selected : userDomain}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        setLoading(false);
        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          if (dashboardcount == 1) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error)
            setdashboardcount(2)
          }
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });
      // SetWidgetcount(datavalue?.data?.data?.score)
      SetWidgetcount(datavalue?.data?.pass_percentage)
      console.log("SetWidgetcountttt", SetWidgetcount)
    } catch (err) {
      console.log(err);
    }
  };


  function capitalizeEachWord(str) {
    let words = str.split(" ");
    for (let i = 0; i < words.length; i++) {
      words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
    }
    return words.join(" ");
  }

  const replacedata = (value) => {
    var Data = value;
    Data = Data.replaceAll("_", " ");
    Data = capitalizeEachWord(Data);
    return Data;
  };

  const OpenRankFilter = () => {
    setIsOpen(true);
  };
  const OpenRankFilterTop = () => {
    setIsOpenTop(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };
  const closeModalTop = () => {
    setIsOpenTop(false);
  };

  const FilterFunctionRank = () => {
    GetdashboardData();
    closeModal();
    setSelectval("");
    setselectvalengine("");
    setselectvalcountry("");
  };

  const LoadFilterOptions = async (type = "", userDomain) => {
    if (type === "rank") {
      try {
        const datavalue = await axios.get(
          `${process.env.REACT_APP_API_URL}domain/get_report_job_details/?user_domain_id=${esodata.domaindata.value.header_selected ? esodata.domaindata.value.header_selected : userDomain}&job_type=rankings_summary`,
          {
            headers: {
              Authorization: `${ApiToken}`,
            },
          }
        ).catch((error) => {
          setLoading(false);
          if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
            if (dashboardcount == 1) {
              setapiOpen(true);
              setapierrorMsg(error?.response?.data?.error)
              setdashboardcount(2)
            }
          }
          else if (error?.code == "ERR_NETWORK") {
            navigate('/errorpages')
          }
        });

        if (datavalue?.data) {
          setcompletedate(datavalue.data.jobs);
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  const LoadSearchEngine = async (jobid = "", userDomain) => {
    setsearchengine([]);
    try {

      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}keywords/ranking_filter/?user_domain_id=${esodata.domaindata.value.header_selected ? esodata.domaindata.value.header_selected : userDomain}&filter_type=search_engine&job_id=${jobid}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        setLoading(false);
        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          if (dashboardcount == 1) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error)
            setdashboardcount(2)
          }
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });

      if (datavalue?.data) {
        setsearchengine(datavalue.data.search_engines);
      }


    } catch (err) {
      console.log(err);
    }
  };

  const LoadCountry = async (jobid = "", userDomain) => {
    setcountry([]);

    try {

      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}keywords/ranking_filter/?user_domain_id=${esodata.domaindata.value.header_selected ? esodata.domaindata.value.header_selected : userDomain}&filter_type=country&job_id=${jobid}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        setLoading(false);
        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          if (dashboardcount == 1) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error)
            setdashboardcount(2)
          }
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });

      if (datavalue?.data) {
        setcountry(datavalue.data.countries);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const TriggersetSelectval = (values) => {
    setSelectval(values);
    LoadCountry(values[0].id, "");
  };

  const Navigateto = (e) => {
    var ClassName = e.target.tagName;
    if (ClassName !== "path" || ClassName === "svg") {
      const LinkAttr = e.target
        .closest(".ranking_summary_col")
        .getAttribute("data-link");

      navigate(LinkAttr);
    }
  };

  const [SeriesDate, SetSeriesDate] = useState([]);
  const [Direct, SetDirect] = useState([]);
  const [OrganicSearch, SetOrganicSearch] = useState([]);
  const [OrganicSocial, SetOrganicSocial] = useState([]);
  const [PaidSearch, SetPaidSearch] = useState([]);
  const [Referral, SetReferral] = useState([]);
  const [Unassigned, SetUnassigned] = useState([]);
  const [pieseriesData, SetpieseriesData] = useState([]);
  const [chartSeries, setChartSeries] = useState([]);

  const [Directpie, SetDirectpie] = useState(0);
  const [OrganicSearchpie, SetOrganicSearchpie] = useState(0);
  const [OrganicSocialpie, SetOrganicSocialpie] = useState(0);
  const [PaidSearchpie, SetPaidSearchpie] = useState(0);
  const [Referralpie, SetReferralpie] = useState(0);
  const [Unassignedpie, SetUnassignedpie] = useState(0);
  const [pieLable, setPieLable] = useState([]);

  const LastSevenDaysTrafficReport = async (userDomain) => {
    setLoading(true);
    SetSeriesDate([]);
    // SetDirect([]);
    // SetOrganicSearch([]);
    // SetOrganicSocial([]);
    // SetPaidSearch([]);
    // SetReferral([]);
    // SetUnassigned([]);

    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}dashboard/traffic_report_graph/?user_domain_id=${esodata.domaindata.value.header_selected ? esodata.domaindata.value.header_selected : userDomain}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        setLoading(false);
        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          if (dashboardcount == 1) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error)
            setdashboardcount(2)
          }
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });

      if (datavalue?.data) {
        if (datavalue?.data?.traffic_result) {
          const datesArray = datavalue.data.traffic_result.map(
            (item) => item.date
          );
          const DirectArray = datavalue.data.traffic_result.map(
            (item) => item.channel.direct
          );
          const OrganicSearchArray = datavalue.data.traffic_result.map(
            (item) => item.channel["organic search"]
          );
          const OrganicSocialArray = datavalue.data.traffic_result.map(
            (item) => item.channel["organic social"]
          );
          const PaidSearchArray = datavalue.data.traffic_result.map(
            (item) => item.channel["paid search"]
          );
          var PaidSocialArray = [];
          let paidSocialCount = datavalue.data.traffic_result.filter(item => item.channel["paid social"] || item.channel["paid social"] >= 0);
          if (paidSocialCount.length > 0) {
            PaidSocialArray = datavalue.data.traffic_result.map(
              (item) => {
                if (item.channel["paid social"] || item.channel["paid social"] >= 0) {
                  return item.channel["paid social"];
                } else {
                  return 0;
                }
              }
            );
          }
          const ReferralArray = datavalue.data.traffic_result.map(
            (item) => item.channel.referral
          );
          const UnassignedArray = datavalue.data.traffic_result.map(
            (item) => item.channel.unassigned
          );
          SetSeriesDate(datesArray);
          // SetDirect(DirectArray);
          // SetOrganicSearch(OrganicSearchArray);
          // SetOrganicSocial(OrganicSocialArray);
          // SetPaidSearch(PaidSearchArray);
          // SetPaidSocial(PaidSocialArray);
          // SetReferral(ReferralArray);
          // SetUnassigned(UnassignedArray);

          var series = [
            { name: "Direct", data: DirectArray },
            { name: "Organic Search", data: OrganicSearchArray },
            { name: "Organic Social", data: OrganicSocialArray },
            { name: "Paid Search", data: PaidSearchArray },
            { name: "Referral", data: ReferralArray },
            { name: "Unassigned", data: UnassignedArray },
          ];

          if (PaidSocialArray.length > 0) {
            series.push({ name: "Paid Social", data: PaidSocialArray });
          };

          setChartSeries(series);

          setLoading(false);
          SetShowTraffic(true);

          var PaidSearch = 0
          var Direct = 0
          var Unassigned = 0
          var OrganicSocial = 0
          var OrganicSearch = 0
          var Referral = 0

          if (datavalue.data.pie_chart) {
            PaidSearch = datavalue.data.pie_chart?.channel['paid search']
            if (datavalue.data.pie_chart?.channel['paid social'] || datavalue.data.pie_chart?.channel['paid social'] >= 0) {
              var PaidSocial = datavalue.data.pie_chart?.channel['paid social'];
            }
            Direct = datavalue.data.pie_chart.channel.direct
            Unassigned = datavalue.data.pie_chart.channel.unassigned
            OrganicSocial = datavalue.data.pie_chart.channel['organic social']
            OrganicSearch = datavalue.data.pie_chart.channel['organic search']
            Referral = datavalue.data.pie_chart.channel.referral
            if (PaidSearch == "" || !PaidSearch)
              PaidSearch = 0;
          }
          // SetPaidSearchpie(PaidSearch)
          // SetDirectpie(Direct)
          // SetUnassignedpie(Unassigned)
          // SetOrganicSocialpie(OrganicSocial)
          // SetOrganicSearchpie(OrganicSearch)
          // SetReferralpie(Referral);
          var pieChartLable = [
            'Direct - ' + Direct,
            'Organic Search - ' + OrganicSearch,
            'Organic Social - ' + OrganicSocial,
            'Paid Search - ' + PaidSearch,
            'Referral - ' + Referral,
            'Unassigned - ' + Unassigned
          ];
          var pieSeriesData = [Direct, OrganicSearch, OrganicSocial, PaidSearch, Referral, Unassigned];

          if (PaidSocial || PaidSocial === 0) {
            pieChartLable.push(`Paid Social - ${PaidSocial}`);
            pieSeriesData.push(PaidSocial);
          }

          setPieLable(pieChartLable);
          SetpieseriesData(pieSeriesData);

        }

        if (datavalue.data.status) {
          if (datavalue.data.status === true || datavalue.data.status === 'error') {
            SetShowTrafficMsg(datavalue.data.message)
            SetShowTraffic(false)
          }
        }
      }
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  const baroptions = {
    chart: {
      type: "bar",
      height: 400,
      width: "100%",
      toolbar: { show: false }
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "60%",
      }
    },
    responsive: [{
      breakpoint: 768,
      options: {
        chart: {
          width: "100%",
          height: 350,
        },
        legend: { show: false },
        dataLabels: { enabled: false }
      }
    }],
    xaxis: {
      type: "category",
      categories: SeriesDate
      ,

      crosshairs: {
        show: false
      },
      labels: {
        offsetX: 50,
        style: { fontSize: "12px" }
      }
    },
    yaxis: {
      labels: { formatter: (val) => Math.round(val) },
    },
    dataLabels: { enabled: false },
    colors: ["#008ffb", "#00e396", "#feb019", "#ff4560", "#775dd0", "#037e88", "#cc00b3"]
  };

  const pieseries = pieseriesData

  const pieoptions = {
    chart: {
      type: "donut",
      height: 350,
    },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        return "<div class='custom_pie_tool_tip'>" + w.config.labels[seriesIndex] + "</div>";
      }
    },
    labels: pieLable,
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: "100%",
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
    legend: {
      position: isMobile || isTablet ? "bottom" : "right",
    },
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        donut: {
          size: "70%",
        },
      },
    },
    colors: ["#008ffb", "#00e396", "#feb019", "#ff4560", "#775dd0", "#037e88", "#cc00b3"]
  };

  const [dEngineoption, SetdEngineoption] = useState([]);
  const [dcountryoption, Setdcountryoption] = useState([]);

  const TopFiveTrafficPages = async (
    metrictype = "",
    search_engine_id = "",
    search_locale = ""
  ) => {
    setLoading(true);
    setTableLoading(true);
    setCardData([]);
    try {


      const result = await axios.get(
        `${process.env.REACT_APP_API_URL}domain/get_user_domains/`, {
        headers: {
          Authorization: `${ApiToken}`,
        },
      }
      )

      var PassUrl = `${process.env.REACT_APP_API_URL}dashboard/top5_traffic_table/?user_domain_id=${esodata.domaindata.value.header_selected ? esodata.domaindata.value.header_selected : result.data[0].id}&top5_param=${metrictype}`

      if (search_engine_id !== '') {
        PassUrl = PassUrl + '&search_engine=' + search_engine_id;
      }
      if (search_locale !== '') {
        PassUrl = PassUrl + '&search_locale=' + search_locale;
      }

      const datavalue = await axios.get(
        PassUrl,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        setLoading(false);
        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          if (dashboardcount == 1) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error)
            setdashboardcount(2)
          }
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });

      if (datavalue?.data?.result) {
        var newData = datavalue.data.result.map((obj, index) => {
          return { ...obj, sid: index + 1 };
        });

        if (metrictype === "Bounce_Rate") {
          newData = newData.map((item) => {
            return { ...item, changed_metrics: item.bounce_rate };
          });
        } else if (metrictype === "Sessions") {
          newData = newData.map((item) => {
            return { ...item, changed_metrics: item.sessions };
          });
        } else if (metrictype === "New_Users") {
          newData = newData.map((item) => {
            return { ...item, changed_metrics: item.new_users };
          });
        } else if (metrictype === "CTR%") {
          newData = newData.map((item) => {
            return { ...item, changed_metrics: item.ctr };
          });
        }

        setCardData(newData);
        SetShowTop(true)
        setLoading(false);
      }

      if (datavalue?.data?.status) {
        if (datavalue.data.status === true || datavalue.data.status === 'error') {
          SetShowTopMsg(datavalue.data.message)
          SetShowTop(false)
        }
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
    setTableLoading(false);
  };

  const FilterFunctionRankTop = async () => {
    SetvalidationTop("");
    var Engine = '';
    var Country = '';
    if (selectvalengineTop !== "") {
      Engine =
        selectvalengineTop[0].search_engine_locale__search_engine__id;
    }
    if (selectvalcountryTop !== "") {
      Country =
        selectvalcountryTop[0].search_engine_locale__city__state__country__id;
    }

    TopFiveTrafficPages(SelectdMetrics, Engine, Country);
    closeModalTop();
  };

  const TopFiveMetricsList = async () => {
    SetTopFiveMetrics([]);
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}dashboard/top5_metrics_list/`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        setLoading(false);
        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          if (dashboardcount == 1) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error)
            setdashboardcount(2)
          }
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });

      if (datavalue?.data) {
        SetSelectdMetrics(datavalue.data.top5_metrics[0]);
        TopFiveTrafficPages(datavalue.data.top5_metrics[0]);
        SetTopFiveMetrics(datavalue.data.top5_metrics);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const menuChange = (e) => {
    var Engine = "";
    var Country = "";
    if (selectvalengineTop !== "" && selectvalcountryTop !== "") {
      Engine = selectvalengineTop[0].search_engine_locale__search_engine__id;
      Country =
        selectvalcountryTop[0].search_engine_locale__city__state__country__id;
    }

    e.preventDefault();
    SetSelectdMetrics(e.target.id);
    TopFiveTrafficPages(e.target.id, Engine, Country);
  };



  function removeUnderscore(inputString) {
    return inputString.replace(/_/g, " ");
  }

  const menuChangeBar = (e) => {
    SetSelectdGraphMetrics(e.target.id);
  };
  const seoMetricData = (data) => {
    if (replacedata(data.seo_metrics) == "Missing Alt Tags")
      return <div className="data">
        <Link to="/onpage-crawl-data/2/18" className="seometricdata"><div className="value">{data.issue_count}</div>
          <div>{replacedata(data.seo_metrics)}</div></Link>
      </div>
    else if (replacedata(data.seo_metrics) === "Hreflang")
      return <div className="data">
        <Link to="/onpage-crawl-data/2/9" className="seometricdata"><div className="value">{data.issue_count}</div>
          <div>{replacedata(data.seo_metrics)}</div></Link>
      </div>
    else if (replacedata(data.seo_metrics) === "Missing Canonical")
      return <div className="data">
        <Link to="/onpage-crawl-data/2/14" className="seometricdata"><div className="value">{data.issue_count}</div>
          <div>{replacedata(data.seo_metrics)}</div></Link>
      </div>
    else if (replacedata(data.seo_metrics) === "Duplicate Titles")
      return <div className="data">
        <Link to="/onpage-crawl-data/2/4" className="seometricdata"><div className="value">{data.issue_count}</div>
          <div>{replacedata(data.seo_metrics)}</div></Link>
      </div>
    else if (replacedata(data.seo_metrics) === "Duplicate Descriptions")
      return <div className="data">
        <Link to="/onpage-crawl-data/2/5" className="seometricdata"><div className="value">{data.issue_count}</div>
          <div>{replacedata(data.seo_metrics)}</div></Link>
      </div>
    else if (replacedata(data.seo_metrics) === "Missing H1 Tags")
      return <div className="data">
        <Link to="/onpage-crawl-data/2/16" className="seometricdata"><div className="value">{data.issue_count}</div>
          <div>{replacedata(data.seo_metrics)}</div></Link>
      </div>
    else if (replacedata(data.seo_metrics) === "Missing Descriptions")
      return <div className="data">
        <Link to="/onpage-crawl-data/2/15" className="seometricdata"><div className="value">{data.issue_count}</div>
          <div>{replacedata(data.seo_metrics)}</div></Link>
      </div>
    else if (replacedata(data.seo_metrics) === "Multiple H1 Tags")
      return <div className="data">
        <Link to="/onpage-crawl-data/2/19" className="seometricdata"><div className="value">{data.issue_count}</div>
          <div>{replacedata(data.seo_metrics)}</div></Link>
      </div>
    else if (replacedata(data.seo_metrics) === "Duplicate H1 Tags")
      return <div className="data">
        <Link to="/onpage-crawl-data/2/7" className="seometricdata"><div className="value">{data.issue_count}</div>
          <div>{replacedata(data.seo_metrics)}</div></Link>
      </div>
    else if (replacedata(data.seo_metrics) === "Missing Titles")
      return <div className="data">
        <Link to="/onpage-crawl-data/2/2" className="seometricdata"><div className="value">{data.issue_count}</div>
          <div>{replacedata(data.seo_metrics)}</div></Link>
      </div>
    else if (replacedata(data.seo_metrics) === "Mismatch Canonical")
      return <div className="data">
        <Link to="/onpage-crawl-data/2/3" className="seometricdata"><div className="value">{data.issue_count}</div>
          <div>{replacedata(data.seo_metrics)}</div></Link>
      </div>
    else if (replacedata(data.seo_metrics) === "No-index robot")
      return <div className="data">
        <Link to="/onpage-crawl-data/2/17" className="seometricdata"><div className="value">{data.issue_count}</div>
          <div>{replacedata(data.seo_metrics)}</div></Link>
      </div>
    else if (replacedata(data.seo_metrics) === "Images Available")
      return <div className="data">
        <Link to="/onpage-crawl-data/2/6" className="seometricdata"><div className="value">{data.issue_count}</div>
          <div>{replacedata(data.seo_metrics)}</div></Link>
      </div>
    else if (replacedata(data.seo_metrics) === "H1 Tags Available")
      return <div className="data">
        <Link to="/onpage-crawl-data/2/20" className="seometricdata"><div className="value">{data.issue_count}</div>
          <div>{replacedata(data.seo_metrics)}</div></Link>
      </div>
    else if (replacedata(data.seo_metrics) === "Broken Links 4xx Link")
      return <div className="data" onClick={pageRedirectfun} style={{ cursor: 'pointer' }}>
        <Link to="/" className="seometricdata" id="1">
          <div className="value">{data.issue_count}</div>
          <div>{replacedata(data.seo_metrics)}</div>
        </Link>
      </div>
    // <div className="data">
    //   <div className="value">{data.issue_count}</div>
    //   <div onClick={pageRedirectfun} id="1" >{replacedata(data.seo_metrics)}</div>
    // </div>

    else if (replacedata(data.seo_metrics) === "Server Error 5xx Link")
      return <div className="data" onClick={pageRedirectfun} style={{ cursor: 'pointer' }}>
        <Link to="/" className="seometricdata" id="2">
          <div className="value">{data.issue_count}</div>
          <div>{replacedata(data.seo_metrics)}</div>
        </Link>
      </div>
    // <div className="data">
    //   <div className="value">{data.issue_count}</div>
    //   <div onClick={pageRedirectfun} id="2">{replacedata(data.seo_metrics)}</div>
    // </div>
  }

  const faqdatafun = async (menubutval = "") => {
    var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=52`
    try {
      const doaminsectiondatavalue = await axios.get(
        datavar,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        setLoading(false);
        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          if (dashboardcount == 1) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error)
            setdashboardcount(2)
          }
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });
      if (doaminsectiondatavalue?.data) {
        SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs)
      }
    } catch (err) { }
  }
  const handleToggle = () => {
    if (faqData != 1) {
      setfaqData(1)
    }
    else {
      setfaqData(2)
    }
    setToggle((pre) => !pre);
  };

  var startColor = "#6495ed";
  var endColor = "#dc143c";
  const interpolate = interpolateRgb(startColor, endColor);
  const fillColor = "rgb(255,174,31)";
  const textfillColor = "rgb(255,255,255)";
  const gradientStops = [
    {
      key: "0%",
      stopColor: color(fillColor).darker(0.5).toString(),
      stopOpacity: 1,
      offset: "0%",
    },
    {
      key: "50%",
      stopColor: fillColor,
      stopOpacity: 0.75,
      offset: "50%",
    },
    {
      key: "100%",
      stopColor: color(fillColor).brighter(0.5).toString(),
      stopOpacity: 0.5,
      offset: "100%",
    },
  ];

  const handleCardClick = (route) => {
    navigate(route);
  };

  const cardData1 = [
    {
      value: RankedKeywords || 0,
      title: "Ranked Keywords",
      badge: "SEO",
      // iconSrc: <BarChartIcon />,
      iconSrc: RankedKeywordssvg,
      iconColor: 1,
      bgColor: 1,
      route: "/ranking-summary/2",
      handleCardClick: handleCardClick
    },
    {
      value: OnPageErrors || 0,
      title: "On Page Errors",
      badge: "LINKS",
      iconSrc: RankedKeywordssvg,
      // iconSrc: <BugReportIcon />,
      iconColor: 2,
      bgColor: 2,
      route: "/onpage-crawl-data/2/1",
      handleCardClick: handleCardClick
    },
    {
      value: TotalInternalLinks || 0,
      title: "Total Internal Links",
      badge: "TRAFFIC",
      iconSrc: RankedKeywordssvg,
      //iconSrc: <LinkIcon />,
      iconColor: 3,
      bgColor: 3,
      route: "/internal-link-checker",
      handleCardClick: handleCardClick
    },
    {
      title: "Visibility Score",
      value: VisibilityScore || 0,

      badge: "INDEXABLE",
      iconSrc: RankedKeywordssvg,
      // iconSrc: <VisibilityIcon />,
      iconColor: 4,
      bgColor: 4,
      route: "/visibility-score-detail",
      handleCardClick: handleCardClick
    },
  ];

  return (

    <div className={`over_all_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Dashboard</title>
      </Helmet>
      {loading === true && !openCommonAlerts ? <Loader /> : null}

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box">
          <Grid container className="dashboard-grid">
            <Grid item xs={6} md={6}>
              <div><h1 className="dashboard_header">
                Dashboard
              </h1>
              </div>
            </Grid>
            <Grid item xs={6} md={6}>
              <div className="top_breadcrumb_menu">
                <nav className="breadcrumb" >
                  <ul className="breadcrumb-links">
                    <li>
                      <span className="breadcrumb-box">
                        <svg
                          className="breadcrumb-icon-home"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M9.293 2.293a1 1 0 011.414 0l7 7A1 1 0 0117 11h-1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3a1 1 0 00-1-1H9a1 1 0 00-1 1v3a1 1 0 01-1 1H5a1 1 0 01-1-1v-6H3a1 1 0 01-.707-1.707l7-7z"
                            clipRule="evenodd"
                          />
                        </svg>
                        <span className="breadcrumb-text" style={{ color: '#ff601f' }}>Dashboard</span>
                      </span>
                    </li>
                  </ul>
                </nav>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-tab">
          <Grid container className="dashboard-grid">
            <Grid container spacing={3} justifyContent="center">
              {cardData1.map((item, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <Commoncard item={item}></Commoncard>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container" style={{ color: '#000', marginBottom: '0px' }}>
        <div className="site_audit_dashboard_outer">
          <div>
            <h3 className="sub_heading_font">Accessibility Score</h3>
            <ProgressBar style={{ padding: '0px' }} score={widgetcount} />
          </div>
        </div>
      </Container>

      <Container maxWidth={false} className="dashboard-container" style={{ color: '#000', marginTop: '0px' }}>
          <h3 className="sub_heading_font site_audit_dashboard_outer" style={{ color: '#000', marginTop: '0px' }}>Accessibility Summary</h3>
          <Box className="dashboard-box-tab">
            <Grid container sclassName="dashboard-grid">
              <Grid container spacing={3} justifyContent="center">
                <Grid item xs={12} sm={6} md={3}>
                  <div class="issue-card red">
                    <div class="issue-header">Critical Issues</div>
                    <div class="issue-stats">
                      <div>
                        <div class="issue-percent">{CriticalPercentage}%</div>
                        <div class="issue-label">of total issues</div>
                      </div>
                      <div class="divider-card"></div>
                      <div>
                        <div class="issue-count">{CriticalCount}</div>
                        <div class="issue-label">out of {TotalIssues}</div>
                      </div>
                    </div>
                    {CriticalData?.length > 0 && (
                      <div className="issue-strip-list">
                        {CriticalData.map((data, index) => (
                          <div className="issue-strip" key={index}>
                            <div className="strip-left">
                              <div className="circle-icon"></div>
                              <span className="issue-type">{replacedata(data.issue_name)}</span>
                            </div>
                            <span className="issue-number">{data.count}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <div class="issue-card orange">
                    <div class="issue-header">Serious Issues</div>
                    <div class="issue-stats">
                      <div>
                        <div class="issue-percent">{SeriousPercentage}%</div>
                        <div class="issue-label">of total issues</div>
                      </div>
                      <div class="divider-card"></div>
                      <div>
                        <div class="issue-count">{SeriousCount}</div>
                        <div class="issue-label">out of {TotalIssues}</div>
                      </div>
                    </div>
                    {SeriousData?.length > 0 && (
                      <div className="issue-strip-list">
                        {SeriousData.map((data, index) => (
                          <div className="issue-strip" key={index}>
                            <div className="strip-left">
                              <div className="circle-icon"></div>
                              <span className="issue-type">{replacedata(data.issue_name)}</span>
                            </div>
                            <span className="issue-number">{data.count}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <div class="issue-card blue">
                    <div class="issue-header">Moderate Issues</div>
                    <div class="issue-stats">
                      <div>
                        <div class="issue-percent">{ModeratePercentage}%</div>
                        <div class="issue-label">of total issues</div>
                      </div>
                      <div class="divider-card"></div>
                      <div>
                        <div class="issue-count">{ModerateCount}</div>
                        <div class="issue-label">out of {TotalIssues}</div>
                      </div>
                    </div>
                    {ModerateData?.length > 0 && (
                      <div className="issue-strip-list">
                        {ModerateData.map((data, index) => (
                          <div className="issue-strip" key={index}>
                            <div className="strip-left">
                              <div className="circle-icon"></div>
                              <span className="issue-type">{replacedata(data.issue_name)}</span>
                            </div>
                            <span className="issue-number">{data.count}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <div class="issue-card green">
                    <div class="issue-header">Minor Issues</div>
                    <div class="issue-stats">
                      <div>
                        <div class="issue-percent">{MinorPercentage}%</div>
                        <div class="issue-label">of total issues</div>
                      </div>
                      <div class="divider-card"></div>
                      <div>
                        <div class="issue-count">{MinorCount}</div>
                        <div class="issue-label">out of {TotalIssues}</div>
                      </div>
                    </div>
                    {MinorData?.length > 0 && (
                      <div className="issue-strip-list">
                        {MinorData.map((data, index) => (
                          <div className="issue-strip" key={index}>
                            <div className="strip-left">
                              <div className="circle-icon"></div>
                              <span className="issue-type">{replacedata(data.issue_name)}</span>
                            </div>
                            <span className="issue-number">{data.count}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Container>

      

      <div className="cnt_audit_outer_wrap">
        {/* <div className="top_breadcrumb_menu">
          <nav className="breadcrumb" >
            <ul className="breadcrumb-links">
              <li>
                <span className="breadcrumb-box">
                  <svg
                    className="breadcrumb-icon-home"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M9.293 2.293a1 1 0 011.414 0l7 7A1 1 0 0117 11h-1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3a1 1 0 00-1-1H9a1 1 0 00-1 1v3a1 1 0 01-1 1H5a1 1 0 01-1-1v-6H3a1 1 0 01-.707-1.707l7-7z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="breadcrumb-text" style={{ color: '#ff601f' }}>Dashboard</span>
                </span>
              </li>
            </ul>
          </nav>
          <div className="exportpdf_outer">
            <button onClick={handleToggle} className="faq_class exportpdf" title="Frequently Asked Question" >
              <QuestionMarkIcon />
            </button>

          </div>
          {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}

        </div> */}
        {/* <div className="cnt_hdr_top_wraps">
          <div className="cnt_hdr_top_lft_wrap">
            <div style={{ display: "flex" }}>
              <h2 className="heading_font" style={{ letterSpacing: "0.8px", fontWeight: 900, color: "#ff601f" }}>Dashboard </h2>
            </div>
          </div>
        </div> */}

        {/* <DashboardCards OnPageErrors={OnPageErrors} RankedKeywords={RankedKeywords} TotalInternalLinks={TotalInternalLinks} VisibilityScore={VisibilityScore} /> */}

        

        


        



        {/* <div>
          <h3 className="sub_heading_font site_audit_dashboard_outer" style={{ color: '#000', marginTop: '0px' }}>Accessibility Summary</h3>
          <Grid container spacing={3}>
            <Grid item xs={3}>
              <div className="cols highimpactissue box_impact4">
                <h3 style={{ color: '#000', textAlign: 'center' }}>Critical Issues</h3>
                <p className="" style={{ color: '#000', textAlign: 'center' }}><span className="box_impact1_perc3">{CriticalPercentage}%</span> of total issues</p>
                <p style={{ color: '#000', textAlign: 'center' }}>
                  <span style={{ color: '#d85151', fontWeight: '500' }}>{CriticalCount}</span> out of <span style={{ color: '#ff601f' }}>{TotalIssues} </span>
                </p>
                {CriticalData?.length > 0 && (
                  <div className="site_data_row text_font" style={{ color: '#000', textAlign: 'center' }}>
                    {CriticalData.map((data, index) => (
                      <div className="highissuedata" key={index}>
                        {ImpactSummaryData(data)}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </Grid>
            <Grid item xs={3}>
              <div className="cols highimpactissue box_impact1">
                <h3 style={{ color: '#000', textAlign: 'center' }} >Serious Issues</h3>
                <p className="" style={{ color: '#000', textAlign: 'center' }}><span className="box_impact1_perc">{SeriousPercentage}%</span> of total issues</p>
                <p className="" style={{ color: '#000', textAlign: 'center' }}>
                  <span style={{ color: '#fc9231', fontWeight: '500' }}>{SeriousCount}</span> out of <span style={{ color: '#ff601f' }}>{TotalIssues}</span>
                </p>
                {SeriousData?.length > 0 && (
                  <div className="site_data_row text_font" style={{ color: '#000', textAlign: 'center' }}>
                    {SeriousData.map((data, index) => (
                      <div className="highissuedata" key={index}>
                        {ImpactSummaryData(data)}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </Grid>
            <Grid item xs={3}>
              <div className="cols highimpactissue box_impact2">
                <h3 style={{ color: '#000', textAlign: 'center' }}>Moderate Issues</h3>
                <p className="" style={{ color: '#000', textAlign: 'center' }}><span className="box_impact1_perc1">{ModeratePercentage}%</span> of total issues</p>
                <p style={{ color: '#000', textAlign: 'center' }}>
                  <span style={{ color: '#33b36b', fontWeight: '500' }}>{ModerateCount}</span> out of <span style={{ color: '#ff601f' }}>{TotalIssues} </span>
                </p>
                {ModerateData?.length > 0 && (
                  <div className="site_data_row text_font" style={{ color: '#000', textAlign: 'center' }}>
                    {ModerateData.map((data, index) => (
                      <div className="highissuedata" key={index}>
                        { ImpactSummaryData(data)}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </Grid>
            <Grid item xs={3}>
              <div className="cols highimpactissue box_impact3">
                <h3 style={{ color: '#000', textAlign: 'center' }}>Minor Issues</h3>
                <p className="" style={{ color: '#000', textAlign: 'center' }}><span className="box_impact1_perc4">{MinorPercentage}%</span> of total issues</p>
                <p style={{ color: '#000', textAlign: 'center' }}>
                  <span style={{ color: '#3d7a81', fontWeight: '500' }}> {MinorCount}</span> out of <span style={{ color: '#ff601f' }}>{TotalIssues}</span>
                </p>
                {MinorData?.length > 0 && (
                  <div className="site_data_row text_font" style={{ color: '#000', textAlign: 'center' }}>
                    {MinorData.map((data, index) => (
                      <div className="highissuedata" key={index}>
                        {ImpactSummaryData(data)}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </Grid>
          </Grid>
        </div> */}

        <div className="site_audit_dashboard_outer" >
          <div style={{ marginTop: '50px' }}>
            <h3 className="sub_heading_font">Site Audit Summary</h3>
          </div>
          <div className="card_row">
            <div className="cols highimpactissue" style={{ background: "#F4F9FE" }}>
              <p className="heading sub_heading1_font">High Impact Issues</p>
              <p className="versus text_font">
                <span className="site_summary_value">{HighPercentage}%</span> of total issues
              </p>
              <p className="versus text_font">
                <span style={{ color: '#0079f2', fontWeight: '500' }}>{HighCount}</span> out of <span style={{ color: '#ff601f', fontWeight: '500' }}>{TotalCount}</span>
              </p>
              {HighIssuesData.length > 0 ?
                <div className="site_data_row text_font">
                  {HighIssuesData.map((data, index) => (
                    <div className="highissuedata" key={index}>
                      {seoMetricData(data)}
                    </div>
                  ))}
                </div> : ""}
            </div>
            <div className="cols" style={{ background: "#FFFAF3" }}>
              <p className="heading sub_heading1_font">Medium Impact Issues</p>
              <p className="versus text_font">
                <span className="site_summary_value">{MediumPercentage}%</span> of total issues
              </p>
              <p className="versus text_font">
                <span style={{ color: '#ffa726', fontWeight: '500' }}>{MediumCount}</span> out of <span style={{ color: '#ff601f', fontWeight: '500' }}>{TotalCount}</span>
              </p>
              {MediumIssuesData.length > 0 ?
                <div className="site_data_row text_font">
                  {MediumIssuesData.map((data, index) => (
                    <div className="highissuedata" key={index}>
                      {seoMetricData(data)}
                    </div>
                  ))}
                </div> : ""}
            </div>
            <div className="cols" style={{ background: "#F8F8FE" }}>
              <p className="heading sub_heading1_font">Low Impact Issues</p>
              <p className="versus text_font">
                <span className="site_summary_value">{LowPercentage}%</span> of total issues
              </p>
              <p className="versus text_font">
                <span style={{ color: '#0000fb', fontWeight: '500' }}>{LowCount}</span> out of <span style={{ color: '#ff601f', fontWeight: '500' }}>{TotalCount}</span>
              </p>
              {LowIssuesData.length > 0 ?
                <div className="site_data_row text_font">
                  {LowIssuesData.map((data, index) => (
                    <div className="highissuedata" key={index}>
                      {seoMetricData(data)}
                    </div>
                  ))}
                </div> : ""}
            </div>
          </div>
        </div>



        <div className="dashboard_traffic_widget">
          {topseventraffic ? (
            ShowTraffic ? (
              <div className="traffic_report_seven_wrap">
                <h3 className="sub_heading_font" style={{ marginTop: '50px' }}>Traffic Report For Last 7 days</h3>
                <div className="site_cnt_hdr_blw_wrap dashboard_traffic_switch">
                  <button
                    type="button"
                    id="line"
                    className={`site_rn_rpt_btn text_font ${"line" === SelectdGraphMetrics ? "active" : ""}`}
                    onClick={menuChangeBar}
                  >
                    Line Chart
                  </button>
                  <button
                    type="button"
                    id="bar"
                    className={`site_rn_rpt_btn text_font ${"bar" === SelectdGraphMetrics ? "active" : ""}`}
                    onClick={menuChangeBar}
                  >
                    Bar Chart
                  </button>
                  <button
                    type="button"
                    id="pie"
                    className={`site_rn_rpt_btn text_font ${"pie" === SelectdGraphMetrics ? "active" : ""}`}
                    onClick={menuChangeBar}
                  >
                    Pie Chart
                  </button>
                </div>
                <div>
                  {SeriesDate.length > 0 ? (
                    <div className="google_area_chart_wrap" style={{ maxWidth: '900px', margin: 'auto', background: "#fff" }}>
                      {SelectdGraphMetrics === "line" && (
                        <div >
                          <ApexCharts options={baroptions} series={chartSeries} type="line" width="100%" height={350} />

                        </div>
                      )}
                      {SelectdGraphMetrics === "bar" && (
                        <div >
                          <ApexCharts options={baroptions} series={chartSeries} type="bar" width="100%" height={400} />
                        </div>

                      )}

                      {SelectdGraphMetrics === "pie" && (
                        <ApexCharts options={pieoptions} series={pieseries} type="donut" height={350} />

                      )}
                    </div>
                  ) : null}
                </div>
              </div>
            ) : (
              <div>
                <h3>Traffic Report For Last 7 days</h3>
                {ShowTrafficMsg && (
                  <div className="google_traffic_error">
                    <ErrorIcon />
                    {ShowTrafficMsg}
                  </div>
                )}
              </div>
            )
          ) : null}
          {topfivetraffic === true && (
            ShowTop ? (
              <div className="top_5_traffic_wrap">
                <h3 className="sub_heading_font" style={{ marginTop: "50px" }}>
                  Top 5 Traffic Pages{" "}
                </h3>
                <div className="site_cnt_hdr_blw_wrap dashboard_traffic_switch">
                  {TopFiveMetrics.map((data, index) => (
                    <button
                      type="button"
                      id={data}
                      className={`site_rn_rpt_btn text_font ${data === SelectdMetrics ? "active" : ""}`}
                      onClick={(e) => menuChange(e)}
                      key={index}
                    >
                      {removeUnderscore(data)}
                    </button>
                  ))}
                </div>
                <div className="data_table" style={{ width: "100%" }}>
                  <DatagridComp
                    columns={columns}
                    rows={rows}
                    autoheightval={autoheightval}
                    datagridval={4}
                    customToolFunction={CustomToolbar}
                    tableLoading={tableLoading}
                  />
                  <div className="metric_notes_row">
                    <div className="row">
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div>
                <h3>Top 5 Traffic Pages</h3>
                {ShowTopMsg && (
                  <div className="google_traffic_error">
                    <ErrorIcon />
                    {ShowTopMsg}
                  </div>
                )}
              </div>
            )
          )}
        </div>
      </div>
      <Container maxWidth={false} className="footer-container">
        <Box className="footer-box">
          <Grid container className="footer-grid">
            <Grid item xs={12} md={6}>
              <div className="footer-left">
                <p className="footer-text">
                  All Rights Reserved Copyright © 2025 |
                  <a href="https://www.egrovesys.com/" target="_blank"> <span className="footer-brand"> eGrove System</span></a>
                </p>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="footer-right">
                <p>{/* Add content if needed */}</p>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>
      <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />
      <Dialog
        open={modalIsOpen}
        onClose={closeModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="competitor_test_filter job_date_filter"
      >
        <DialogTitle className="keyword-dialog-header">{"Ranking Keyword/Visibility Score"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div className="cnt_hdr_blw_wrap row">
              <div>
                <div className="">
                  <div>
                    <span>Completed Date</span>
                    <Select
                      labelField="completed_at"
                      valueField="id"
                      options={completedate}
                      onChange={(values) => TriggersetSelectval(values)}
                    />
                  </div>
                </div>

                <div className="">
                  <div>
                    <span>Search Engine</span>
                    <Select
                      labelField="search_engine_locale__search_engine__name"
                      valueField="search_engine_locale__search_engine__id"
                      options={searchengine}
                      onChange={(values) => setselectvalengine(values)}
                    />
                  </div>
                </div>
                <div className="">
                  <div>
                    <span>Country</span>
                    <Select
                      labelField="search_engine_locale__country__name"
                      valueField="search_engine_locale__country__id"
                      options={country}
                      onChange={(values) => setselectvalcountry(values)}
                    />
                  </div>
                </div>

                <div className="col">
                  <span className="text-error">{validation.dateerror}</span>
                </div>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">
          <button
            className="form_submit_btn"
            onClick={FilterFunctionRank}
            style={{ cursor: "pointer" }}
          >
            Submit
          </button>
          <button style={{ cursor: "pointer" }} onClick={closeModal}>
            close
          </button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={modalIsOpenTop}
        onClose={closeModalTop}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="competitor_test_filter job_date_filter"
      >
        <DialogTitle className="keyword-dialog-header">{"Top 5 Traffic Pages"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div className="cnt_hdr_blw_wrap row">
              <div>
                <div className="">
                  <div>
                    <span>Search Engine</span>
                    <Select
                      values={[dEngineoption]}
                      labelField="search_engine_locale__search_engine__name"
                      valueField="search_engine_locale__search_engine__id"
                      options={searchengine}
                      onChange={(values) => {
                        setselectvalengineTop(values);
                      }}
                    />
                  </div>
                </div>

                <div className="">
                  <div>
                    <span>Country</span>
                    <Select
                      values={[dcountryoption]}
                      labelField="search_engine_locale__country__name"
                      valueField="search_engine_locale__country__id"
                      options={country}
                      onChange={(values) => {
                        setselectvalcountryTop(values);
                        Setdcountryoption({
                          search_engine_locale__country__name:
                            values[0]
                              .search_engine_locale__country__name,
                          search_engine_locale__country__id:
                            values[0]
                              .search_engine_locale__country__id,
                        });
                      }}
                    />
                  </div>
                </div>

                <div className="col">
                  <span className="text-error">{validationTop}</span>
                </div>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">
          <button
            className="form_submit_btn"
            onClick={FilterFunctionRankTop}
            style={{ cursor: "pointer" }}
          >
            Submit
          </button>
          <button style={{ cursor: "pointer" }} onClick={closeModalTop}>
            close
          </button>
        </DialogActions>
      </Dialog>

      {!openCommonAlerts &&
        <CommonErrorAlert
          data={{
            apiopen: apiopen,
            apiErrorMsg: apierrorMsg,
            isIconStyled: false
          }}
          closeAlert={apihandleClose} />
      }

    </div>
  );
};

export default MainDashboard;
